import HomeStartUpAbout from "components/abouts/home-stratup-about";
import AboutCta from "components/cta/about-cta";
import StartUpFaqs from "components/faqs/start-up-faqs";
import StartupFeatures from "components/features/startup-features";
import HomeStartupBanner from "components/hero-banners/home-startup-banner";
import SEO from "components/seo";
import StartUpSupport from "components/supports/start-up-support";
import ServicesVision from "components/visions/services-vision";
import FooterSeven from "layout/footers/footer-7";
import HeaderSix from "layout/headers/header-6";
import Wrapper from "layout/wrapper";
import React from "react";
import { Link } from "react-router-dom";
import CustomPortfolio from "./custom-portfolio";
import FreelancerCta from "components/cta/freelancer-cta";
import AgencyCta from "components/cta/agency-cta";
import AboutFaqs from "components/abouts/about-page-com/about/about-faqs";
import HomePortFolio from "data/home-portfolio";
import HomePopup from "components/common/home-popup";
import HomeTrustedBrands from "components/brands/home-trusted-brands";

const Anouncement = () => {
  return (
    <>
      <div className="row justify-content-center mb-2">
        <div className="col-xxl-10 col-xl-10 col-lg-11">
          <div
            className="features__offer text-center mt-20 wow fadeInUp"
            data-wow-delay=".9s"
            data-wow-duration="1s"
          >
            <span>LIVE NOW</span>
            <p>
              {" "}
              {/* If you want to join the effort and help with the plugin, please{" "} */}
              Experience Ghar360's Interactive Property Walkthrough Demo on the
              <Link to="https://play.google.com/store/apps/details?id=com.rionick.ghar360">
                {" "}
                Google Play Store
              </Link>
              {/* from our upcoming modeling and animation library. */}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const HomeStartUp = () => {
  return (
    <>
      <Wrapper>
        <SEO
          metaTitle={"Rionick- 3D Modeling & Animation services | NFT Arts"}
          metaDesc={
            "We provide best-in-class 3D services like 3D Modeling, 3D Animation, NFT Art, Website Development services and Digital Marketing services."
          }
          metaKeywords={
            "3d modeling services, 3d animation, game development services, top digital marketing services, 2d game development"
          }
          canonical="https://www.rionick.com"
          pageTitle={"Rionick Studio | Home"}
        />
        <HeaderSix />
        <HomePopup />
        <HomeStartupBanner />
        {/* <StartupFeatures /> */}
        <HomeStartUpAbout />
        <Anouncement />
        <HomeTrustedBrands />
        <ServicesVision />
        <AgencyCta
          content="LET’S TALK ABOUT YOUR NEXT PROJECT"
          title="Looking for customized 3D Models at scale?"
          btext="Get In Touch"
          bclr="tp-btnr bg-danger tp-btn-shine-effect"
          element_style={true}
        />
        <AboutFaqs
          element_style={true}
          head={"Built for Modern Real Estate Sales"}
          title={"Sell your Apartment Before You Build with Ghar360"}
          desc={
            "Step inside your future property before it's even built. Ghar360 transforms architectural plans into immersive real-time experiences, allowing buyers to explore every room, compare furnished and unfurnished interiors, visualize actual balcony views, and interact with the property just as they would in real life. Designed for builders and sales teams, it helps buyers make faster, more confident purchasing decisions."
          }
        />
        <CustomPortfolio data={HomePortFolio} />
        <StartUpSupport />
        <StartUpFaqs />
        <FooterSeven />
      </Wrapper>
    </>
  );
};

export default HomeStartUp;
